import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=04fd61b9&scoped=true"
import script from "./topBanner.vue?vue&type=script&lang=js"
export * from "./topBanner.vue?vue&type=script&lang=js"
import style0 from "./topBanner.vue?vue&type=style&index=0&id=04fd61b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd61b9",
  null
  
)

export default component.exports